import script from "./package-form-step1.vue?vue&type=script&lang=ts&setup=true"
export * from "./package-form-step1.vue?vue&type=script&lang=ts&setup=true"

import "./package-form-step1.vue?vue&type=style&index=0&id=c0a0b29a&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0a0b29a"]])

export default __exports__